import { useTranslation } from 'react-i18next';
import { OrgSettingsForm } from '@/components/dashboard/OrgSettingsForm';

export default function OrganizationSettingsNew() {
  const { t } = useTranslation();

  return (
    <div className="flex-1 space-y-6 p-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">{t('org.settings')}</h2>
        <p className="text-muted-foreground">
          Manage your organization settings, logo, and report configuration.
        </p>
      </div>

      <OrgSettingsForm />
    </div>
  );
}